import { render } from "./AspectContainer.vue?vue&type=template&id=65409128"
import script from "./AspectContainer.vue?vue&type=script&lang=js"
export * from "./AspectContainer.vue?vue&type=script&lang=js"

import "./AspectContainer.vue?vue&type=style&index=0&id=65409128&lang=scss"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__